import React, { useState, useEffect, Fragment } from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';
import {
  Box, Button, Card, makeStyles, Container, CardHeader, CardContent,
  Divider, MenuItem, Grid, InputLabel, TextField
} from '@material-ui/core';
import Page from 'src/components/Page';
import PageHeader from 'src/views/Common/PageHeader';
import services from '../Services';
import { Formik } from 'formik';
import * as Yup from "yup";
import { useNavigate } from 'react-router-dom';
import { trackPromise } from 'react-promise-tracker';
import authService from '../../../utils/permissionAuth';
import tokenService from '../../../utils/tokenDecoder';
import MaterialTable from "material-table";
import { useAlert } from "react-alert";
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import { KeyboardDatePicker } from "@material-ui/pickers";
import moment from 'moment';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  },
  avatar: {
    marginRight: theme.spacing(2)
  },
  row: {
    marginTop: '1rem'
  }
}));

const screenCode = 'NEWMANUFACTURING';

export default function NewManufacturingListing() {
  const [title, setTitle] = useState("Manufacturing");
  const classes = useStyles();
  const [GroupList, setGroupList] = useState([]);
  const [FactoryList, setFactoryList] = useState([]);
  const [IDDataForDefaultLoad, setIsIDDataForDefaultLoad] = useState(null);
  const [manufacturingDetail, setManufacturingDetail] = useState({
    groupID: 0,
    factoryID: 0,
    fromDate: new Date(),
    toDate: new Date(),
    statusID: 0
  });
  const [manufactureList, setManufactureList] = useState([]);
  const [permissionList, setPermissions] = useState({
    isGroupFilterEnabled: false,
    isFactoryFilterEnabled: false,
    isApproveButtonEnabled: false
  });
  const navigate = useNavigate();
  const alert = useAlert();
  let encrypted = "";
  let encryptedStatus = "";
  const handleClick = () => {
    encrypted = btoa('0');
    encryptedStatus = btoa('0');
    navigate('/app/newmanufacturing/addEdit/' + encrypted + '/' + encryptedStatus)
  }

  useEffect(() => {
    trackPromise(
      getGroupsForDropdown());
  }, []);

  useEffect(() => {
    trackPromise(
      getFactoriesForDropdown());
  }, [manufacturingDetail.groupID]);

  useEffect(() => {
    const IDdata = JSON.parse(
      sessionStorage.getItem('manufacturing-listing-page-search-parameters-id')
    );
    getPermission(IDdata);
  }, []);

  useEffect(() => {
    sessionStorage.removeItem('manufacturing-listing-page-search-parameters-id');
  }, []);

  useEffect(() => {
    if (IDDataForDefaultLoad != null || IDDataForDefaultLoad != undefined) {
      GetManufacturingList();
    }
  }, [IDDataForDefaultLoad]);

  async function getPermission(IDdata) {
    var permissions = await authService.getPermissionsByScreen(screenCode);
    var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWNEWMANUFACTURING');
    if (isAuthorized === undefined) {
      navigate('/404');
    }
    var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
    var isFactoryFilterEnabled = permissions.find(p => p.permissionCode == 'FACTORYDROPDOWN');
    var isApproveButtonEnabled = permissions.find(p => p.permissionCode == 'APPROVEBUTTON');

    setPermissions({
      ...permissionList,
      isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
      isFactoryFilterEnabled: isFactoryFilterEnabled !== undefined,
      isApproveButtonEnabled: isApproveButtonEnabled !== undefined
    });

    const initialValues = IDdata == null;
    if (initialValues) {
      setManufacturingDetail({
        ...manufacturingDetail,
        groupID: parseInt(tokenService.getGroupIDFromToken()),
        factoryID: parseInt(tokenService.getFactoryIDFromToken())
      })
    }
    else {
      setManufacturingDetail({
        ...manufacturingDetail,
        groupID: parseInt(IDdata?.groupID),
        factoryID: parseInt(IDdata?.factoryID),
        fromDate: new Date(IDdata?.fromDate),
        toDate: new Date(IDdata?.toDate),
        statusID: parseInt(IDdata?.statusID),
      })
    }
    setIsIDDataForDefaultLoad(IDdata)
  }

  async function getGroupsForDropdown() {
    const groups = await services.getGroupsForDropdown();
    setGroupList(groups);
  }

  async function getFactoriesForDropdown() {
    const factories = await services.getFactoryByGroupID(manufacturingDetail.groupID);
    setFactoryList(factories);
  }

  async function GetManufacturingList() {
    const response = await services.GetManufactureDetailsToManufactureScreen(
      manufacturingDetail.groupID,
      manufacturingDetail.factoryID,
      manufacturingDetail.fromDate,
      manufacturingDetail.toDate,
      parseInt(manufacturingDetail.statusID)
    );
    if (response.length > 0) {
      setManufactureList(response);
    }
    else {
      alert.error('No records to display');
    }
  }

  function generateDropDownMenu(data) {
    let items = []
    if (data != null) {
      for (const [key, value] of Object.entries(data)) {
        items.push(<MenuItem key={key} value={key}>{value}</MenuItem>);
      }
    }
    return items;
  }

  function generateFactoryDropDownMenu(data) {
    let items = []
    if (data != null) {
      const sortedFactories = [...FactoryList].sort((a, b) =>
        a.factoryName.localeCompare(b.factoryName)
      );
      sortedFactories.forEach(x => {
        items.push(<MenuItem key={x.factoryID} value={x.factoryID}>{x.factoryName}</MenuItem>)
      });
    }
    return items
  }

  function handleChange(e) {
    const target = e.target;
    const value = target.value
    setManufacturingDetail({
      ...manufacturingDetail,
      [e.target.name]: value
    });
    setManufactureList([]);
  }

  function handleFromDateChange(value) {
    setManufacturingDetail({
      ...manufacturingDetail,
      fromDate: value
    });
    setManufactureList([]);
  }

  function handleToDateChange(value) {
    setManufacturingDetail({
      ...manufacturingDetail,
      toDate: value
    });
    setManufactureList([]);
  }

  const handleClickEdit = (manufacturingID, statusID) => {
    encrypted = btoa(manufacturingID.toString());
    encryptedStatus = btoa(statusID.toString());
    let model = {
      groupID: parseInt(manufacturingDetail.groupID),
      factoryID: parseInt(manufacturingDetail.factoryID),
      fromDate: moment(manufacturingDetail.fromDate).format('YYYY-MM-DD'),
      toDate: moment(manufacturingDetail.toDate).format('YYYY-MM-DD'),
      statusID: parseInt(manufacturingDetail.statusID),
    }
    sessionStorage.setItem('manufacturing-listing-page-search-parameters-id', JSON.stringify(model));
    navigate('/app/newmanufacturing/addEdit/' + encrypted + '/' + encryptedStatus);
  }

  function clearFormFields() {
    setManufacturingDetail({
      ...manufacturingDetail,
      statusID: 0,
      date: new Date()
    });
    setManufactureList([]);
  }

  function cardTitle(titleName) {
    return (
      <Grid container spacing={1}>
        <Grid item md={10} xs={12}>
          {titleName}
        </Grid>
        <Grid item md={2} xs={12}>
          <PageHeader
            onClick={handleClick}
            isEdit={true}
            toolTiptitle={"Add Manufacturing"}
          />
        </Grid>
      </Grid>
    )
  }

  return (
    <Fragment>
      <Page className={classes.root} title={title}>
        <Container maxWidth={false}>
          <Formik
            initialValues={{
              groupID: manufacturingDetail.groupID,
              factoryID: manufacturingDetail.factoryID,
              fromDate: manufacturingDetail.fromDate,
              toDate: manufacturingDetail.toDate,
            }}
            validationSchema={
              Yup.object().shape({
                groupID: Yup.number().required('Group is required').min("1", 'Group is required'),
                factoryID: Yup.number().required('Factory is required').min("1", 'Factory is required'),
                fromDate: Yup.date().typeError('Invalid From date').nullable(),
                toDate: Yup.date().typeError('Invalid To date').nullable()
              })
            }
            onSubmit={() => trackPromise(GetManufacturingList())}
            enableReinitialize
          >
            {({
              errors,
              handleBlur,
              handleSubmit,
              touched
            }) => (
              <form onSubmit={handleSubmit}>
                <Box mt={0}>
                  <Card>
                    <CardHeader title={cardTitle(title)} />

                    <Divider />
                    <CardContent>
                      <Grid container spacing={3}>
                        <Grid item md={3} xs={12}>
                          <InputLabel shrink id="groupID">
                            Group *
                          </InputLabel>
                          <TextField select
                            error={Boolean(touched.groupID && errors.groupID)}
                            fullWidth
                            helperText={touched.groupID && errors.groupID}
                            name="groupID"
                            onBlur={handleBlur}
                            onChange={(e) => handleChange(e)}
                            value={manufacturingDetail.groupID}
                            variant="outlined"
                            id="groupID"
                            disabled={!permissionList.isGroupFilterEnabled}
                            size='small'
                          >
                            <MenuItem value="0">--Select Group--</MenuItem>
                            {generateDropDownMenu(GroupList)}
                          </TextField>
                        </Grid>
                        <Grid item md={3} xs={12}>
                          <InputLabel shrink id="factoryID">
                            Factory *
                          </InputLabel>
                          <TextField select
                            error={Boolean(touched.factoryID && errors.factoryID)}
                            fullWidth
                            helperText={touched.factoryID && errors.factoryID}
                            name="factoryID"
                            onBlur={handleBlur}
                            onChange={(e) => handleChange(e)}
                            value={manufacturingDetail.factoryID}
                            variant="outlined"
                            id="factoryID"
                            disabled={!permissionList.isFactoryFilterEnabled}
                            size='small'
                          >
                            <MenuItem value="0">--Select Factory--</MenuItem>
                            {generateFactoryDropDownMenu(FactoryList)}
                          </TextField>
                        </Grid>
                        <Grid item md={3} xs={8}>
                          <InputLabel shrink id="fromDate">
                            Manufacture From Date
                          </InputLabel>
                          <MuiPickersUtilsProvider utils={DateFnsUtils}>
                            <KeyboardDatePicker
                              error={Boolean(touched.fromDate && errors.fromDate)}
                              helperText={touched.fromDate && errors.fromDate}
                              autoOk
                              fullWidth
                              variant="inline"
                              format="dd/MM/yyyy"
                              inputVariant="outlined"
                              id="fromDate"
                              size='small'
                              name="fromDate"
                              value={manufacturingDetail.fromDate}
                              onChange={(e) => handleFromDateChange(e)}
                              KeyboardButtonProps={{
                                'aria-label': 'change fromDate',
                              }}
                              InputProps={{ readOnly: true }}
                            />
                          </MuiPickersUtilsProvider>
                        </Grid>
                        <Grid item md={3} xs={8}>
                          <InputLabel shrink id="toDate">
                            Manufacture To Date
                          </InputLabel>
                          <MuiPickersUtilsProvider utils={DateFnsUtils}>
                            <KeyboardDatePicker
                              error={Boolean(touched.toDate && errors.toDate)}
                              helperText={touched.toDate && errors.toDate}
                              autoOk
                              fullWidth
                              variant="inline"
                              format="dd/MM/yyyy"
                              inputVariant="outlined"
                              id="toDate"
                              size='small'
                              name="toDate"
                              value={manufacturingDetail.toDate}
                              onChange={(e) => handleToDateChange(e)}
                              KeyboardButtonProps={{
                                'aria-label': 'change toDate',
                              }}
                              InputProps={{ readOnly: true }}
                            />
                          </MuiPickersUtilsProvider>
                        </Grid>

                        <Grid item md={3} xs={12}>
                          <InputLabel shrink id="statusID">
                            Status
                          </InputLabel>
                          <TextField select
                            fullWidth
                            name="statusID"
                            onBlur={handleBlur}
                            onChange={(e) => handleChange(e)}
                            value={manufacturingDetail.statusID}
                            variant="outlined"
                            id="statusID"
                            size='small'
                          >
                            <MenuItem value="0">--Select Status--</MenuItem>
                            <MenuItem value="1">Withering Done</MenuItem>
                            <MenuItem value="2">Rolling Done</MenuItem>
                            <MenuItem value="3">Firing Done</MenuItem>
                            <MenuItem value="4">Grading Done</MenuItem>
                            <MenuItem value="5">Completed</MenuItem>
                          </TextField>
                        </Grid>
                      </Grid>
                      <Box display="flex" justifyContent="flex-end" p={2} >
                        <Button
                          color="primary"
                          type="reset"
                          variant="outlined"
                          onClick={() => clearFormFields()}
                          size='small'
                        >
                          Clear
                        </Button>
                        <div>&nbsp;</div>
                        <Button
                          color="primary"
                          type="submit"
                          variant="contained"
                          size='small'
                        >
                          Search
                        </Button>
                      </Box>
                    </CardContent>
                    <PerfectScrollbar>
                      <Box minWidth={1050}>
                        <Card >
                          {manufactureList.length > 0 ?
                            <MaterialTable
                              title="Multiple Actions Preview"
                              columns={[
                                { title: 'Factory', field: 'factoryName' },
                                { title: 'Mf . Type', field: 'manufactureTypeName' },
                                { title: 'Mf . No', field: 'manufactureNumber' },
                                {
                                  title: 'Mf. Date (From)', field: 'fromDateOfManufaturing',
                                  render: rowData => rowData.fromDateOfManufaturing.split('T')[0]
                                },
                                {
                                  title: 'Mf. Date (To)', field: 'toDateOfManufaturing',
                                  render: rowData => rowData.toDateOfManufaturing.split('T')[0]
                                },
                                {
                                  title: 'Status', field: 'statusID',
                                  render: rowData => {
                                    if (rowData.statusID == 1)
                                      return "Withering Done"
                                    else if (rowData.statusID == 2)
                                      return "Rolling Done"
                                    else if (rowData.statusID == 3)
                                      return "Firing Done"
                                    else if (rowData.statusID == 4)
                                      return "Grading Done"
                                    else if (rowData.statusID == 5)
                                      return "Completed"
                                    else return "Completed"
                                  }
                                },
                                // {
                                //   title: 'Approve Status', field: 'approveStatusID',
                                //   render: rowData => {
                                //     if (rowData.approveStatusID == 1)
                                //       return "Pending"
                                //     else if (rowData.approveStatusID == 2)
                                //       return "Approved"
                                //     else if (rowData.approveStatusID == 3)
                                //       return "Rejected"
                                //     else return ""
                                //   }
                                // }
                              ]}
                              data={manufactureList}
                              options={{
                                exportButton: false,
                                showTitle: false,
                                headerStyle: { textAlign: "left" },
                                cellStyle: { textAlign: "left" },
                                columnResizable: false,
                                actionsColumnIndex: -1,
                                pageSize: 5,
                              }}
                              actions={[
                                rowData => ({
                                  hidden: (rowData.approveStatusID == 2 || rowData.approveStatusID == 3),
                                  icon: 'edit',
                                  tooltip: 'Edit',
                                  onClick: (event, rowData) => handleClickEdit(rowData.manufacturingID, 1),
                                }),
                                rowData => ({
                                  hidden: (rowData.approveStatusID == 1),
                                  icon: 'visibility',
                                  tooltip: 'View',
                                  onClick: (event, rowData) => handleClickEdit(rowData.manufacturingID, 2)
                                }),
                                rowData => ({
                                  hidden: (rowData.approveStatusID == 2 || rowData.approveStatusID == 3 || !permissionList.isApproveButtonEnabled),
                                  icon: 'check',
                                  tooltip: 'Approve',
                                  onClick: (event, rowData) => handleClickEdit(rowData.manufacturingID, 3)
                                }),

                              ]}
                            />
                            : null}
                        </Card>
                      </Box>
                    </PerfectScrollbar>
                  </Card>
                </Box>
              </form>
            )}
          </Formik>
        </Container>
      </Page>
    </Fragment>
  );
}
